import React from 'react';
import { MapPin, Phone, Clock } from 'lucide-react';
import Seo, { breadcrumbSchema } from '@/components/Seo';
import Breadcrumbs from '@/components/Breadcrumbs';
import Reveal from '@/components/Reveal';
import LeadForm from '@/components/LeadForm';
import { WhatsAppButton, CallButton } from '@/components/CTAButtons';
import { SITE } from '@/config';
import { IMAGES } from '@/data/siteData';

const Contact = () => (
  <>
    <Seo
      title="Contact Provident Palm Vista | Book a Site Visit"
      description="Contact Provident Palm Vista Shilphata — call or WhatsApp +91 88798 56585 for price, floor plans, brochure and site visits. Site office on Kalyan-Shilphata Road, Mumbai 421204."
      path="/contact"
      jsonLd={[breadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Contact', path: '/contact' }])]}
    />
    <section className="pt-28 md:pt-36 pb-16 md:pb-24 bg-ivory min-h-[70vh]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Breadcrumbs items={[{ name: 'Contact' }]} />
        <div className="grid lg:grid-cols-2 gap-12 items-start">
          <Reveal>
            <p className="text-xs font-semibold tracking-[0.25em] uppercase text-gold">Get in Touch</p>
            <h1 className="font-display text-4xl sm:text-5xl font-medium text-palm mt-3 leading-[1.08] tracking-tight">Contact Provident Palm Vista</h1>
            <p className="text-[15px] text-ink/75 mt-5 leading-relaxed">
              For the latest price, floor plans, brochure, availability or to book a site visit, reach us on WhatsApp or call directly — or share your details and we will get in touch.
            </p>
            <div className="space-y-4 mt-8">
              <div className="flex items-start gap-3 bg-white border border-line rounded-2xl p-5">
                <MapPin className="h-5 w-5 text-gold mt-0.5 shrink-0" />
                <div>
                  <p className="font-semibold text-palm text-sm">Site Address</p>
                  <p className="text-sm text-muted-foreground mt-1 leading-relaxed">{SITE.address}</p>
                </div>
              </div>
              <div className="flex items-start gap-3 bg-white border border-line rounded-2xl p-5">
                <Phone className="h-5 w-5 text-gold mt-0.5 shrink-0" />
                <div>
                  <p className="font-semibold text-palm text-sm">Call & WhatsApp</p>
                  <p className="text-sm text-muted-foreground mt-1">{SITE.phoneDisplay}</p>
                  <div className="flex flex-wrap gap-2 mt-3">
                    <WhatsAppButton testid="contact-whatsapp-btn" className="!px-4 !py-2.5 !text-xs" />
                    <CallButton testid="contact-call-btn" className="!px-4 !py-2.5 !text-xs" />
                  </div>
                </div>
              </div>
              <div className="flex items-start gap-3 bg-white border border-line rounded-2xl p-5">
                <Clock className="h-5 w-5 text-gold mt-0.5 shrink-0" />
                <div>
                  <p className="font-semibold text-palm text-sm">Site Visits</p>
                  <p className="text-sm text-muted-foreground mt-1 leading-relaxed">Site visits are arranged daily. Share your details or call us to confirm a convenient slot.</p>
                </div>
              </div>
            </div>
            <img src={IMAGES.siteOffice} alt="Provident Palm Vista site experience centre, Kalyan-Shilphata Road" className="rounded-3xl w-full object-cover aspect-video mt-6 shadow-lg" loading="lazy" width={1080} height={875} />
          </Reveal>
          <Reveal delay={0.15}>
            <div className="bg-white border border-line rounded-3xl p-6 sm:p-8 shadow-xl lg:sticky lg:top-28">
              <h2 className="font-display text-2xl sm:text-3xl font-medium text-palm">Request a Call Back</h2>
              <p className="text-sm text-muted-foreground mt-2 mb-6">Get price, floor plans, brochure and current offers.</p>
              <LeadForm source="contact_page" testidPrefix="contact-form" />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  </>
);

export default Contact;
